import React from "react";
import { transformApiError } from "common/api/errors";
import Panel from "common/components/Panel";
import actions from "./actions";
import Form from "./Form";
import { PREFERRED_LANGS } from "common/constants";

const handleSubmit = async (values, form) => {
  const body = {
    email: values.email,
    access_level: values.accessLevel === "user" ? null : values.accessLevel,
    first_name: values.firstName,
    last_name: values.lastName,
    password: values.password,
    phone: values.phone,
    lang_pref: values.langPref,
  };

  try {
    await actions.create(body);
    form.resetForm();
    form.setStatus({ success: true });
  } catch (error) {
    const apiError = transformApiError(error);
    if (apiError.empty()) {
      form.setErrors({ http: error.message });
    } else {
      form.setErrors(apiError.object());
    }
  }
  form.setSubmitting(false);
};

const initialValues = {
  email: "",
  accessLevel: "",
  firstName: "",
  lastName: "",
  password: "",
  phone: "",
  langPref: PREFERRED_LANGS[0].value,
};

const Create = () => (
  <Panel title="Create User">
    <Form handleSubmit={handleSubmit} initialValues={initialValues} />
  </Panel>
);

export default Create;
